module.exports = __webpack_public_path__ + "img/electronic_pending_zone.714815d4.svg";